var objTicketEmailHistory = {
    // <summary>
    // This object holds all functions for email history related functionality in ticket.js
    // </summary>

    _fetchEmailHistory: function (me) {
        /// <summary>
        ///  This function fetches the email history list
        /// </summary>
       
        try {
            if (me.error) { return false; }
            if (me.specific.readOnlyMode) return true;

            me.getData({ TypeId: 7, 'TicketID': me.specific.ticketId }, function (result) {

                if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }

                objTicketEmailHistory._fillEmailHistory(me, result);
                me.myHtml.rowEmailHistory.wrapper.show();

                return true;
            });
            return true;
        } catch (ex) { me._writeErr(e); return false }

    },

    _fillEmailHistory: function (me, data) {
        /// <summary>
        ///  This function generates a vc-list for all data entries incl. a selection checkbox
        /// </summary>
        var item;
        var ul;
       
        try {
            if (me.error) { return false; }

            me.myHtml.rowEmailHistory.divEmailList.html(me.getLoadingIcon());
         
            if (data.length == 0) {
                me.myHtml.rowEmailHistory.divEmailList.html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return true;
            }


            ul = $("<ul>").attr("id", "lst-email-history").addClass("vc-list-selection");


            for (i = 0; i < data.length; i++) {
                var line = me._setListItem();
               
                line.column.append(me._setListElement("", "w15").html(data[i].Date));
                var typeId = data[i].EmailType;
                var type = "";
                switch (typeId) {
                    case 1: //change
                        type = me.specific.resources.edited; break;
                    case 2: //monthly reminder
                        type = me.specific.resources.monthlyReminder; break;
                    case 3: //completion reminder
                        type = me.specific.resources.completionReminder; break;
                    //case 4: //completion reminder
                    //    type = me.specific.resources.; break;
                    case 5: //
                        type = me.specific.resources.firstReminder; break;
                    case 6: //
                        type = me.specific.resources.secondReminder; break;
                    case 7: //
                        type = me.specific.resources.lastReminder; break;
                    default:
                }
                line.column.append(me._setListElement("", "w20").html(type));

                var users = "";
                for (j = 0; j < data[i].Users.length; j++) {
                    users += data[i].Users[j] + "; ";
                }
                line.column.append(me._setListElement("", "w65").html(users));
                ul.append(line.item);

            }

            me.myHtml.rowEmailHistory.divEmailList.html(ul);
            ul.find(".vc-list-item").removeClass("alt").filter(":even").addClass("alt");
            //me._setAltListStyle(ul);



            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },
};

